import React from "react";

const Obs = ({texto}) => {
    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                padding: "40px 20px",
                fontFamily: "'Inter', sans-serif",
                marginBottom: "40px",
            }}
        >
            <div
                style={{
                    maxWidth: "800px",
                    width: "100%",
                    background: "#aee8ae9a",
                    border: "1px solid #5de75d",
                    borderRadius: "10px",
                    padding: "22px 28px",
                }}
            >
                <span
                    style={{
                        display: "block",
                        color: "#27AE60",
                        fontSize: "14px",
                        fontWeight: "700",
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        marginBottom: "14px",
                    }}
                >
                    Você sabia?
                </span>

                <p
                    style={{
                        margin: 0,
                        color: "#145214",
                        fontSize: "15px",
                        lineHeight: 1.3,
                        fontWeight: 400,
                        textAlign: "justify",
                    }}
                >
                    {texto}
                </p>
            </div>
        </div>
    );
};

export default Obs;